import src from "IMAGE";
export default { src, width: 291, height: 55, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AAQRF1gCCg42AgkMLAILDzcDDRFAAgkMLgQRGFkCCw85AAQSGF4EFBtnBBQbYQQSGVwEEhlcAwwQQAQSGVsFFx910oAHVfDYbZsAAAAASUVORK5CYII="};
